import React from 'react';
import {Tooltip, useTheme} from '@mui/material';

const RequiredAsterisk = ()=>{
    let theme = useTheme();
    return <Tooltip title="שדה חובה" placement="top">
      <span style={{color: theme.palette.error.main, marginRight: '2px', marginLeft: '2px'}}>*</span>
    </Tooltip>;
};

export default RequiredAsterisk;
